<template>
  <v-container fluid grid-list-sm style="padding: 8px;">
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-btn icon class="mx-2 mr-4" :to="{name: 'users'}"><v-icon>clear</v-icon></v-btn>
            Invite Users
            <v-file-input
            accept=".csv,.txt"
            class="ml-2"
            label="Upload CSV file"
            v-model="file"
            ></v-file-input>
            <v-menu open-on-hover left>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on"><v-icon>help_outline</v-icon></v-btn>
              </template>
              <v-card><v-card-text>
                Upload a txt or csv file containing one email address per line for each individual you would like to invite to join this site.
              </v-card-text></v-card>
            </v-menu>
          </v-card-title>
          <v-container fluid>
            <v-layout row wrap>
              <v-flex xs12>
                <v-btn class="ma-2" depressed color="success" @click="addItem()">Add Row</v-btn>
                <v-btn class="ma-2" depressed color="primary" @click="inviteUsers()">
                  <v-icon class="pr-2">send</v-icon>
                  Invite Users
                </v-btn>
              </v-flex>
              <v-form v-model="formValid" ref="form" style="width: 100%;">
                <template v-for="(item, i) in this.users">
                  <v-flex xs12 :key="i">
                    <v-text-field
                    append-icon="delete"
                    @click:append="deleteItem(i)"
                    :error-messages="errors[i]"
                    flat
                    hide-details="auto"
                    outlined
                    v-model="item.email"
                    :rules="rulesEmail"
                    solo>
                    </v-text-field>
                  </v-flex>
                </template>
              </v-form>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  <error-snackbar v-model="errorText"></error-snackbar>
  </v-container>
</template>

<script>
import Papa from 'papaparse'
import { mapGetters } from 'vuex'

import ApiRequests from '@/api/ApiRequests'
import ErrorSnackbar from '@/components/ErrorSnackbar'
import Rules from '@/shared/rules'

export default {
  components: {
    ErrorSnackbar
  },

  data () {
    return {
      errors: [],
      errorText: '',
      file: null,
      formValid: true,
      rulesEmail: [
        v => Rules.email(v)
      ],
      users: [
        {
          email: ''
        }
      ]
    }
  },

  computed: {
    ...mapGetters([
      'selectedSite'
    ])
  },

  watch: {
    file: function () {
      if (this.file) {
        Papa.parse(this.file, {
          complete: (r) => {
            this.users = []
            for (var line of r.data) {
              console.log(line)
              this.users.push({
                email: line.email
              })
            }
          },
          header: true
        })
      }
    }
  },

  methods: {
    addItem: function () {
      this.users.push({
        email: ''
      })
    },

    deleteItem: function (index) {
      this.users.splice(index, 1)
    },

    inviteUsers: function () {
      this.$refs.form.validate()
      if (this.formValid) {
        var body = {
          users: this.users
        }
        ApiRequests.siteUserImport(this.selectedSite._id, body).then(r => {
          this.errorText = 'Invitation Sent'
          this.errors = r.data
        }).catch(e => {
          this.errorText = 'Error: ' + e.response.data
        })
      } else {
        this.errorText = 'All rows must be valid email addresses'
      }
    }
  }
}
</script>
